import { render, staticRenderFns } from "./RPCompactReviewCard.vue?vue&type=template&id=a7232424&"
import script from "./RPCompactReviewCard.vue?vue&type=script&lang=js&"
export * from "./RPCompactReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./RPCompactReviewCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports